import React from 'react';

const config = {
  admin:   { label: 'Admin',   bg: '#fef3c7', color: '#d97706' },
  manager: { label: 'Manager', bg: '#dbeafe', color: '#2563eb' },
  viewer:  { label: 'Viewer',  bg: '#f1f5f9', color: '#64748b' },
};

export default function RoleBadge({ role }) {
  const c = config[role] || config.viewer;
  return (
    <span style={{
      display: 'inline-block',
      padding: '0.2rem 0.625rem',
      borderRadius: '999px',
      fontSize: '0.75rem',
      fontWeight: '600',
      background: c.bg,
      color: c.color,
    }}>
      {c.label}
    </span>
  );
}
